import React from "react";
import { ArrowRight } from "@phosphor-icons/react";
import { useGov } from "@/hooks/governance";
import { ipfsToHttp } from "@/lib/format";
import { Badge, HashCell } from "@/components/primitives";
import { GovPageShell, GovCard, GovRow, GovError, GovSkeleton, GovEmpty, useGovNav } from "@/components/governance/GovShell";

export const Constitution = ({ meta }) => {
  const navigate = useGovNav();
  const { data: d, error, loading, refetch } = useGov("/governance/constitution");
  const href = ipfsToHttp(d?.anchor?.url);
  return (
    <GovPageShell crumbs={meta.crumbs} title={meta.title} subtitle="The current on-chain constitution and guardrails script.">
      {error ? (
        <GovError error={error} onRetry={refetch} />
      ) : loading && !d ? (
        <GovSkeleton lines={6} />
      ) : d ? (
        <>
          <GovCard>
            <GovRow label="Constitution">#{d.constitution_id}</GovRow>
            <GovRow label="Status"><Badge tone="success">{d.current ? "current" : "historical"}</Badge></GovRow>
            <GovRow label="Effective From">{d.effective_from_epoch != null ? `epoch ${d.effective_from_epoch}` : "—"}</GovRow>
            <GovRow label="Document">
              {href ? (
                <a href={href} target="_blank" rel="noreferrer" data-testid="constitution-doc" className="text-primary hover:underline break-all">{d.anchor?.url} ↗</a>
              ) : "—"}
            </GovRow>
            <GovRow label="Anchor Hash"><HashCell value={d.anchor?.data_hash} len={12} /></GovRow>
            <GovRow label="Guardrails Script"><HashCell value={d.guardrail_script_hash} len={12} /></GovRow>
            {d.enacted_by ? <GovRow label="Enacted">epoch {d.enacted_by.enacted_epoch}</GovRow> : null}
          </GovCard>
          <button
            type="button"
            data-testid="constitution-history-link"
            onClick={() => navigate("/governance/constitution/history")}
            className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] mono text-primary hover:gap-2.5 transition-all"
          >
            View constitution history <ArrowRight size={13} />
          </button>
        </>
      ) : <GovEmpty>Constitution unavailable.</GovEmpty>}
    </GovPageShell>
  );
};
